/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* ============================================================
   Mini Wishlist Toggle
   data-action="toggle-mini-wishlist" lives on the outer wrapper
   div so the inner .wkh-button markup stays completely intact
   for the Wishlist King app integration.
   ============================================================ */
(function () {
  'use strict';

  function openMiniWishlist(wrapper, panel) {
    // Close other open drawers BEFORE marking wishlist as open.
    // This keeps state consistent: when the synthetic clicks below fire,
    // `mini-wishlist-open` is not yet on body so cross-close listeners are silent.
    var openMenuToggle = document.querySelector('[data-action="toggle-menu"][aria-expanded="true"]');
    if (openMenuToggle) openMenuToggle.click();

    // Always close search drawer if open
    var searchBarWrapper = document.querySelector('.header__search-bar-wrapper.is-visible');
    if (searchBarWrapper) {
      searchBarWrapper.classList.remove('is-visible');
      searchBarWrapper.classList.remove('is-fixed');
      searchBarWrapper.closest('header').classList.remove('header--search-expanded');
      // Optionally also update aria-hidden if used
      //searchBarWrapper.setAttribute('aria-hidden', 'true');
      //document.body.classList.remove('no-mobile-scroll');
    }

    var openSearchToggle = document.querySelector('[data-action="toggle-search"][aria-expanded="true"]');
    if (openSearchToggle) openSearchToggle.click();

    // Close any open popover (account login/register drawer, locale, currency, etc.)
    // PopoverManager handles the close when we click the same expanded toggle.
    var openPopoverToggle = document.querySelector('[data-action="toggle-popover"][aria-expanded="true"]');
    if (openPopoverToggle) openPopoverToggle.click();

    if (wrapper) wrapper.setAttribute('aria-expanded', 'true');
    panel.setAttribute('aria-hidden', 'false');
    document.body.classList.add('mini-wishlist-open');
    document.body.classList.add('no-mobile-scroll');

    if (window.matchMedia('(max-width: 640px)').matches) {
      _calculateMiniWishlistHeight(panel);
    }

    // Close mini-cart if it is open
    var miniCart = document.querySelector('.mini-cart[aria-hidden="false"]');
    if (miniCart) {
      miniCart.setAttribute('aria-hidden', 'true');
      var cartToggle = document.querySelector('[data-action="toggle-mini-cart"][aria-expanded="true"]');
      if (cartToggle) {
        cartToggle.setAttribute('aria-expanded', 'false');
        var cartIcon = cartToggle.querySelector('.header__cart-icon');
        if (cartIcon) cartIcon.setAttribute('aria-expanded', 'false');
      }
      document.body.classList.remove('mini-cart-open');
    }
  }

  function closeMiniWishlist(wrapper, panel) {
    if (wrapper) wrapper.setAttribute('aria-expanded', 'false');
    if (panel) {
      panel.setAttribute('aria-hidden', 'true');
      panel.style.removeProperty('max-height');
    }
    document.body.classList.remove('mini-wishlist-open');
    document.body.classList.remove('no-mobile-scroll');
  }

  function getActiveWrapperAndPanel() {
    var panel = document.querySelector('.mini-wishlist[aria-hidden="false"]');
    var wrapper = document.querySelector('[data-action="toggle-mini-wishlist"][aria-expanded="true"]');
    return { panel: panel, wrapper: wrapper };
  }

  function _calculateMiniWishlistHeight(panel) {
    var maxHeight;
    var announcementBar = document.getElementById('shopify-section-announcement-bar');
    if (document.body.classList.contains('subheader-enabled') && announcementBar && announcementBar.getBoundingClientRect().bottom > 0) {
      maxHeight = window.innerHeight - announcementBar.getBoundingClientRect().bottom;
    } else {
      var activeHeader = document.querySelector('.shopify-section__header.active .header') || document.querySelector('.header');
      maxHeight = activeHeader ? window.innerHeight - activeHeader.getBoundingClientRect().bottom : window.innerHeight;
    }
    panel.style.maxHeight = maxHeight + 'px';
    var wrapper = panel.querySelector('.mini-wishlist__wrapper');
    if (wrapper) wrapper.style.maxHeight = maxHeight + 'px';
  }

  // ── toggle on wrapper click (captures clicks on wkh-button too) ─

  document.addEventListener('click', function (e) {
    // Primary: walk up from click target to the [data-action] toggle wrapper.
    var wrapper = e.target.closest('[data-action="toggle-mini-wishlist"]');
    var panel = null;

    if (wrapper) {
      var panelId = wrapper.getAttribute('aria-controls');
      panel = panelId ? document.getElementById(panelId) : null;
    }

    // Fallback: handles cases where WK's App Block re-wraps the inner button,
    // breaking the ancestor chain on the primary [data-action] lookup.
    if (!panel) {
      var container = e.target.closest('.header__action-item--wishlist');
      if (container) {
        var candidate = container.querySelector('.mini-wishlist');
        // Never toggle when the tap is inside the open panel itself.
        if (candidate && !candidate.contains(e.target)) {
          panel   = candidate;
          wrapper = wrapper || container.querySelector('[data-action="toggle-mini-wishlist"]');
        }
      }
    }

    if (!panel) return;

    e.preventDefault();
    e.stopPropagation();

    var isOpen = panel.getAttribute('aria-hidden') === 'false';
    if (isOpen) {
      closeMiniWishlist(wrapper, panel);
    } else {
      openMiniWishlist(wrapper, panel);
    }
  }, true); // capture phase — fires before WK's own click handler

  // ── close on outside click ────────────────────────────────

  document.addEventListener('click', function (e) {
    if (!document.body.classList.contains('mini-wishlist-open')) return;
    var state = getActiveWrapperAndPanel();
    if (!state.panel) return;
    if (
      state.panel.contains(e.target) ||
      (state.wrapper && state.wrapper.contains(e.target))
    ) return;
    closeMiniWishlist(state.wrapper, state.panel);
  });

  // ── close on Escape key ───────────────────────────────────

  document.addEventListener('keyup', function (e) {
    if (e.key !== 'Escape') return;
    if (!document.body.classList.contains('mini-wishlist-open')) return;
    var state = getActiveWrapperAndPanel();
    closeMiniWishlist(state.wrapper, state.panel);
  });

  // ── WK drawer close button ────────────────────────────────

  document.addEventListener('click', function (e) {
    if (!e.target.closest('#wishlist-drawer-close')) return;
    var state = getActiveWrapperAndPanel();
    if (state.panel) closeMiniWishlist(state.wrapper, state.panel);
  });

  // ── close wishlist when any other header action is triggered ──────────────
  // Covers: cart toggle, menu toggle, search toggle, account link

  document.addEventListener('click', function (e) {
    if (
      !e.target.closest('[data-action="toggle-mini-cart"]') &&
      !e.target.closest('[data-action="toggle-menu"]') &&
      !e.target.closest('[data-action="toggle-search"]') &&
      !e.target.closest('.header__action-item--account')
    ) return;
    var state = getActiveWrapperAndPanel();
    if (state.panel) closeMiniWishlist(state.wrapper, state.panel);
  });

  // ── inline panel close button ─────────────────────────────

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-action="close-mini-wishlist"]')) return;
    var state = getActiveWrapperAndPanel();
    if (state.panel) closeMiniWishlist(state.wrapper, state.panel);
  });

})();

(function () {
  'use strict';

  // Only run on real pointer devices (mouse, trackpad) that support hover
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var LEAVE_DELAY = 150; // ms before closing after mouse leaves

  var initialized = new WeakSet();

  function closeAllOpenPopovers() {
    document.querySelectorAll('.header__action-item .popover[aria-hidden="false"]').forEach(function (panel) {
      panel.setAttribute('aria-hidden', 'true');
      if (panel.id) {
        // Close every toggle that controls this panel (there may be one per header)
        document.querySelectorAll('[aria-controls="' + panel.id + '"]').forEach(function (t) {
          t.setAttribute('aria-expanded', 'false');
        });
      }
    });
  }

  function attachPopoverHoverToContainer(container, toggleSelector) {
    if (initialized.has(container)) return;

    var toggle = container.querySelector(toggleSelector);
    if (!toggle) return;

    // Resolve panel inside THIS container — avoids the duplicate-ID pitfall
    var panelId = toggle.getAttribute('aria-controls');
    var panel = (panelId ? container.querySelector('[id="' + panelId + '"]') : null)
                || container.querySelector('.popover');
    if (!panel) return;

    var leaveTimer = null;

    function openOnHover() {
      clearTimeout(leaveTimer);
      if (toggle.getAttribute('aria-expanded') === 'true') return;
      closeAllOpenPopovers();      // close sibling popovers first
      toggle.setAttribute('aria-expanded', 'true');
      panel.setAttribute('aria-hidden', 'false');
    }

    // Direct close — no click event fired, so it cannot bubble to cart handler
    function scheduleClose() {
      leaveTimer = setTimeout(function () {
        if (toggle.getAttribute('aria-expanded') !== 'true') return;
        toggle.setAttribute('aria-expanded', 'false');
        panel.setAttribute('aria-hidden', 'true');
      }, LEAVE_DELAY);
    }

    function cancelClose() {
      clearTimeout(leaveTimer);
    }

    container.addEventListener('mouseenter', openOnHover);
    container.addEventListener('mouseleave', scheduleClose);
    // Keep panel open when the mouse drifts into the panel itself
    panel.addEventListener('mouseenter', cancelClose);
    panel.addEventListener('mouseleave', scheduleClose);

    initialized.add(container);
  }

  /** Initialise (or re-initialise) all current popover containers. */
  function initPopovers() {
    document.querySelectorAll('.header__action-item--locale').forEach(function (c) {
      attachPopoverHoverToContainer(c, '[data-action="toggle-popover"]');
    });
    document.querySelectorAll('.header__action-item--currency').forEach(function (c) {
      attachPopoverHoverToContainer(c, '[data-action="toggle-popover"]');
    });
    document.querySelectorAll('.header__action-item--account').forEach(function (c) {
      attachPopoverHoverToContainer(c, '[data-action="toggle-popover"]');
    });
  }

  /**
   * Cart hover handler.
   *
   * Uses direct aria/class manipulation (anchor workaround).
   * Before opening the mini-cart it closes any open popovers directly so that
   * their deferred "close-click" timers never fire and bubble to the cart handler.
   */
  function attachWishlistHover() {
    document.querySelectorAll('.header__action-item--wishlist').forEach(function (container) {
      if (initialized.has(container)) return;

      var toggle = container.querySelector('[data-action="toggle-mini-wishlist"]');
      var panel  = container.querySelector('.mini-wishlist');
      if (!toggle || !panel) return;

      var leaveTimer = null;

      function openWishlist() {
        clearTimeout(leaveTimer);
        if (document.body.classList.contains('mini-wishlist-open')) return;
        closeAllOpenPopovers();
        toggle.setAttribute('aria-expanded', 'true');
        panel.setAttribute('aria-hidden', 'false');
        document.body.classList.add('mini-wishlist-open');
      }

      function scheduleCloseWishlist() {
        leaveTimer = setTimeout(function () {
          if (!document.body.classList.contains('mini-wishlist-open')) return;
          toggle.setAttribute('aria-expanded', 'false');
          panel.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('mini-wishlist-open');
        }, LEAVE_DELAY);
      }

      function cancelClose() { clearTimeout(leaveTimer); }

      container.addEventListener('mouseenter', openWishlist);
      container.addEventListener('mouseleave', scheduleCloseWishlist);
      panel.addEventListener('mouseenter', cancelClose);
      panel.addEventListener('mouseleave', scheduleCloseWishlist);

      initialized.add(container);
    });
  }

  function attachCartHover() {
    document.querySelectorAll('.header__action-item--cart').forEach(function (container) {
      if (initialized.has(container)) return;

      var toggle   = container.querySelector('[data-action="toggle-mini-cart"]');
      var miniCart = container.querySelector('.mini-cart');
      if (!toggle || !miniCart) return;

      var leaveTimer = null;

      function openCart() {
        clearTimeout(leaveTimer);
        if (document.body.classList.contains('mini-cart-open')) return;
        // Close any open popovers directly (no click) so their pending timers
        // cannot later bubble a click to this cart's outside-click handler.
        closeAllOpenPopovers();
        toggle.setAttribute('aria-expanded', 'true');
        miniCart.setAttribute('aria-hidden', 'false');
        document.body.classList.add('mini-cart-open');
      }

      function scheduleCloseCart() {
        leaveTimer = setTimeout(function () {
          if (!document.body.classList.contains('mini-cart-open')) return;
          toggle.setAttribute('aria-expanded', 'false');
          var cartIcon = toggle.querySelector('.header__cart-icon');
          if (cartIcon) cartIcon.setAttribute('aria-expanded', 'false');
          miniCart.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('mini-cart-open');
        }, LEAVE_DELAY);
      }

      function cancelClose() { clearTimeout(leaveTimer); }

      container.addEventListener('mouseenter', openCart);
      container.addEventListener('mouseleave', scheduleCloseCart);
      miniCart.addEventListener('mouseenter', cancelClose);
      miniCart.addEventListener('mouseleave', scheduleCloseCart);

      initialized.add(container);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    attachCartHover();
    attachWishlistHover();
    initPopovers();

    // Watch for headers inserted after DOMContentLoaded (dynamic brand switching)
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!(node instanceof HTMLElement)) return;
          var found = node.querySelectorAll
            ? node.querySelectorAll(
                '.header__action-item--locale, .header__action-item--currency, ' +
                '.header__action-item--account, .header__action-item--cart, ' +
                '.header__action-item--wishlist'
              )
            : [];
          if (
            found.length > 0 ||
            (node.classList && (
              node.classList.contains('header__action-item--locale') ||
              node.classList.contains('header__action-item--currency') ||
              node.classList.contains('header__action-item--account') ||
              node.classList.contains('header__action-item--cart') ||
              node.classList.contains('header__action-item--wishlist')
            ))
          ) {
            attachCartHover();
            attachWishlistHover();
            initPopovers();
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });

})();
